import { useState } from "react";
import { pollOptions } from "@/mocks/guagua";

export default function Poll() {
  const [voted, setVoted] = useState<number | null>(null);

  return (
    <section id="poll" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <p className="text-xs md:text-sm font-medium tracking-wide text-primary-500">🗳️ 今天来投个票</p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              热门话题 · 你来站队
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              围观完段子也别闲着，说说你的看法。选一个你最有共鸣的话题，看看大家站哪边。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-2xl bg-accent-100 px-4 py-3 text-sm text-accent-900">
              <span className="text-lg">🍉</span>
              已收集 <span className="font-heading text-lg">11,800</span> 票 · 你也来投一票
            </div>
          </div>

          <div className="lg:col-span-3 flex flex-col gap-4">
            {pollOptions.map((opt, i) => {
              const isPicked = voted === i;
              return (
                <button
                  key={opt.label}
                  type="button"
                  disabled={voted !== null}
                  onClick={() => setVoted(i)}
                  className={`group relative overflow-hidden rounded-2xl border p-4 text-left transition-colors ${
                    isPicked
                      ? "border-primary-400 bg-primary-50"
                      : voted === null
                      ? "border-background-200 bg-background-100 hover:border-primary-300"
                      : "border-background-200 bg-background-100 opacity-70"
                  }`}
                >
                  <div className="relative flex items-center justify-between gap-3">
                    <span className="text-sm md:text-base font-medium text-foreground-950">{opt.label}</span>
                    <span className="flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-600">
                      {voted !== null && (
                        <>
                          <i className="ri-team-line text-primary-500"></i>
                          {opt.pct}%
                        </>
                      )}
                      {voted === i && <i className="ri-checkbox-circle-fill text-primary-600 text-xl"></i>}
                    </span>
                  </div>
                  {voted !== null && (
                    <div
                      className={`absolute bottom-0 left-0 top-0 -z-0 ${isPicked ? "bg-primary-100" : "bg-secondary-100"}`}
                      style={{ width: `${opt.pct}%` }}
                      aria-hidden="true"
                    />
                  )}
                </button>
              );
            })}
            {voted !== null && (
              <p className="text-xs text-foreground-500">
                已投票，感谢参与！结果仅供参考，仅供娱乐哦。
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}